import React, { useState } from "react";
import apiClient from "../../../../../api/apiClient";
import { leadDisplayName } from "../shared/crmConstants";

const STEPS = ["Review", "Account Setup", "Done"];

const ConvertLeadModal = ({ lead, onClose, onConverted }) => {
    const [step, setStep] = useState(0);
    const [form, setForm] = useState({
        firstName: lead.firstName || "",
        lastName: lead.lastName || "",
        email: lead.email || "",
        phone: lead.phone || "",
    });
    const [converting, setConverting] = useState(false);
    const [error, setError] = useState("");
    const [result, setResult] = useState(null);

    const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

    const handleConvert = async () => {
        setError("");
        setConverting(true);
        try {
            const res = await apiClient.post(`/admin/crm/leads/${lead.id}/convert`, form);
            setResult(res.data);
            setStep(2);
            onConverted && onConverted();
        } catch (err) {
            setError(err.response?.data?.error || "Conversion failed");
        } finally {
            setConverting(false);
        }
    };

    return (
        <div className="crm-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="crm-modal">
                <div className="crm-modal__header">
                    <h2 className="crm-modal__title">Convert Lead to DYC User</h2>
                    <button className="crm-modal__close" onClick={onClose}>×</button>
                </div>
                <div className="crm-modal__body">
                    {/* Step indicator */}
                    <div className="crm-wizard-steps">
                        {STEPS.map((s, i) => (
                            <React.Fragment key={s}>
                                <div className={`crm-wizard-step ${i < step ? "done" : i === step ? "active" : ""}`}>
                                    <div className="crm-wizard-step-num">{i < step ? "✓" : i + 1}</div>
                                    <span>{s}</span>
                                </div>
                                {i < STEPS.length - 1 && <div className="crm-wizard-step-sep" />}
                            </React.Fragment>
                        ))}
                    </div>

                    {step === 0 && (
                        <div>
                            <p style={{ marginBottom: 16, fontSize: 14 }}>
                                Review lead information before creating a DYC platform account.
                                An invitation email will be sent automatically.
                            </p>
                            <div className="crm-lead-info-row">
                                <span className="crm-lead-info-label">Name</span>
                                <span className="crm-lead-info-value">{leadDisplayName(lead)}</span>
                            </div>
                            <div className="crm-lead-info-row">
                                <span className="crm-lead-info-label">Email</span>
                                <span className="crm-lead-info-value">{lead.email}</span>
                            </div>
                            <div className="crm-lead-info-row">
                                <span className="crm-lead-info-label">Company</span>
                                <span className="crm-lead-info-value">{lead.company || "—"}</span>
                            </div>
                        </div>
                    )}

                    {step === 1 && (
                        <div>
                            <p style={{ marginBottom: 16, fontSize: 14 }}>
                                Confirm account details. A temporary password will be generated and sent via email.
                            </p>
                            {error && <p style={{ color: "#ef4444", marginBottom: 12 }}>{error}</p>}
                            <div className="admin-form-row">
                                <div className="admin-form-group">
                                    <label>First Name *</label>
                                    <input className="admin-input" required value={form.firstName} onChange={set("firstName")} />
                                </div>
                                <div className="admin-form-group">
                                    <label>Last Name *</label>
                                    <input className="admin-input" required value={form.lastName} onChange={set("lastName")} />
                                </div>
                            </div>
                            <div className="admin-form-row">
                                <div className="admin-form-group">
                                    <label>Email *</label>
                                    <input className="admin-input" required type="email" value={form.email} onChange={set("email")} />
                                </div>
                                <div className="admin-form-group">
                                    <label>Phone</label>
                                    <input className="admin-input" value={form.phone} onChange={set("phone")} />
                                </div>
                            </div>
                            <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 8 }}>
                                Platform role will be set to <strong>user</strong>.
                            </p>
                        </div>
                    )}

                    {step === 2 && (
                        <div style={{ textAlign: "center", padding: "16px 0" }}>
                            <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
                            <p style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Lead converted successfully!</p>
                            <p style={{ fontSize: 13, color: "#6b7280" }}>
                                An invitation email has been sent to <strong>{form.email}</strong>.
                            </p>
                            {result?.userId && (
                                <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 8 }}>
                                    User ID: {result.userId}
                                </p>
                            )}
                        </div>
                    )}
                </div>
                <div className="crm-modal__footer">
                    {step === 0 && (
                        <>
                            <button className="admin-btn" onClick={onClose}>Cancel</button>
                            <button className="admin-btn admin-btn--primary" onClick={() => setStep(1)}>Next →</button>
                        </>
                    )}
                    {step === 1 && (
                        <>
                            <button className="admin-btn" onClick={() => { setError(""); setStep(0); }}>← Back</button>
                            <button className="admin-btn admin-btn--primary" onClick={handleConvert} disabled={converting}>
                                {converting ? "Converting…" : "Convert & Send Invite"}
                            </button>
                        </>
                    )}
                    {step === 2 && (
                        <button className="admin-btn admin-btn--primary" onClick={onClose}>Done</button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConvertLeadModal;
